






























































import Vue from 'vue'

import { client } from '@/services/ApiClient'
import { formatDate } from '@/utils'

interface PaySlipInfo {
  id: string
  month: string
}

interface YearlyPaySlipInfo {
  year: number
  paySlips: PaySlipInfo[]
}

const sortDates = (list: PaySlipDTO[]): PaySlipDTO[] => {
  const sortableList = [...list]
  sortableList.sort((a, b) => a.date.getTime() - b.date.getTime())

  return sortableList
}

export default Vue.extend({
  name: 'Home',

  beforeRouteEnter(_to, _from, next) {
    // User must be logged in. Otherwise redirect to login.
    next((vm: Vue & { fetchList?: () => Promise<void> }) => {
      if (!vm.$root.$data.isLoggedIn) {
        vm.$router.replace({ name: 'Login' })
      } else {
        vm.fetchList && vm.fetchList()
      }
    })
  },
  data: () => ({
    isLoading: true as boolean,
    list: [] as PaySlipDTO[],
    downloading: {} as { [key: string]: boolean },
    hasError: false,
  }),

  computed: {
    yearlyPaySlips(): YearlyPaySlipInfo[] {
      const years = Object.keys(
        this.list.reduce((a, { date }) => ({ ...a, [date.getFullYear()]: true }), {}),
      ).map(n => parseInt(n))
      years.sort().reverse()

      return years.map(year => ({
        year,
        paySlips: sortDates(
          this.list.filter(({ date }) => date.getFullYear() === year),
        ).map(({ id, date }) => ({ id, month: formatDate(date) })),
      }))
    },
  },

  methods: {
    async fetchList() {
      this.isLoading = true
      this.list = await client.getPaySlips()
      this.isLoading = false
    },

    async downloadFile({ id, month }: PaySlipInfo): Promise<void> {
      this.downloading = { ...this.downloading, [id]: true }
      try {
        const url = window.URL.createObjectURL(await client.downloadPaySlip(id))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${month}.pdf`)
        ;(this.$refs['fileContainer'] as Element).appendChild(link)
        link.click()
      } catch (e) {
        console.debug('Error downloading file.', e)
        this.hasError = true
      } finally {
        this.downloading = { ...this.downloading, [id]: false }
      }
    },
  },
})
